<template>
    <div class="pop_up_layer" v-show="state.isShow" :style="{ display: state.isShow ? 'block' : 'none' }" @click="fnEvent"></div>
    <div class="pop_up _terms" v-show="state.isShow" :style="{ display: state.isShow ? 'block' : 'none' }">
        <button class="close_btn icon_wrap" @click="fnEvent">
            <img src="img/close_btn2.png" alt="닫기" />
        </button>
        <div class="pop_tit">
            <p>{{ props.title }}</p>
        </div>
        <div class="content_wrap custom_scroll" v-html="props.content"></div>
    </div>
</template>
<script lang="ts">
    import { onMounted, reactive, watch, onUnmounted } from "@/BaseComponent";

    export default {
        props: {
            isShow: {
                type: Boolean,
                default: false,
            },
            title: {
                type: String,
                default: "",
            },
            content: {
                type: String,
                default: "",
            },
        },
        emits: ["close"],
        setup(props: any, { emit }: any) {
            const state = reactive({
                isShow: false as Boolean,
            });

            onMounted(() => {
                state.isShow = props.isShow;

                document.body.style.overflow = "hidden";
            });

            onUnmounted(() => {
                document.body.style.overflow = "";
            });

            const fnEvent = () => {
                emit("close");
            };
            return { state, fnEvent, props };
        },
    };
</script>
